var _defs, _circle, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-2 {\n        font-family: Roobert-Medium, Roobert;\n        font-size: 9px;\n        font-weight: 500;\n      }\n\n      .cls-3 {\n        letter-spacing: 0em;\n      }\n\n      .cls-4 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-5 {\n        letter-spacing: 0em;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 37.5,
    cy: 39.77,
    r: 29
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m44.17,26.57c4.94,2.46,8.33,7.55,8.33,13.44,0,8.28-6.72,15-15,15s-15-6.72-15-15c0-5.89,3.39-10.98,8.33-13.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 37.5,
    y1: 21.53,
    x2: 37.5,
    y2: 33.3
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(0 -6.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 7.01,
    y: 0
  }, "ff"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.88,
    y: 0,
    xmlSpace: "preserve"
  }, " - "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 21.21,
    y: 0
  }, "B"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.85,
    y: 0
  }, "ut"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 32.08,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.42,
    y: 0
  }, "on"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffButton);
export default __webpack_public_path__ + "static/media/__OffButton.364abedf7ae067dae5d6f1869a44575a.svg";
export { ForwardRef as ReactComponent };